<div class="flex flex-column gap-3 w-full">
  <button pButton type="button" [loading]="isGoogleLoading" (click)="initiateGoogleLogin()"
    class="social-btn google-btn w-full">
    <img src="assets/icons/google.svg" alt="Google" width="24" height="24">
    <span>
      {{ loginType === 'signIn' ? 'Continue with Google' : 'Continue with Google' }}
    </span>
  </button>

  <!-- <button pButton type="button" [loading]="isLinkedInLoading" (click)="initiateLinkedInLogin()"
    class="social-btn linkedin-btn w-full">
    <img src="assets/icons/linked-in.svg" alt="LinkedIn" width="24" height="24">
    <span>
      {{ loginType === 'signIn' ? 'Continue with LinkedIn' : 'Continue with LinkedIn' }}
    </span>
  </button> -->
</div>